import React, { useState } from 'react'
import { ArrowLeftIcon, ArrowRightIcon, XCircleIcon } from '@heroicons/react/outline'

export default function Step3({ prevStep, nextStep, updateFieldValue, value }) {

    const [selected, setSelected] = useState(value)
    const [error, showError] = useState(false)

    const handleNextStep = () => {
        if (selected === "") {
            showError(true)
        } else {
            updateFieldValue("unfiledTaxReturns", selected);
            nextStep(3)
        }
    }

    const handleForward = (v) => {
        setSelected(v)
        updateFieldValue("unfiledTaxReturns", v);
        nextStep(3)
    }


    return (

        <div id="step3">
            <div className='max-w-lg mx-auto p-10'>
                <fieldset>
                    <legend className='font-normal text-base px-6'>Do have one or more unfiled tax returns?</legend>
                    <div className='mt-5 ml-2 text-base text-gray-800'>
                        <div className='py-1'>
                            <input type="radio" id="unfiledTaxReturns-yes" defaultChecked={value === "Yes"} onClick={() => handleForward("Yes")} name="do_have_one_or_more_unfiled_tax_returns_" value="yes" />
                            <label htmlFor="unfiledTaxReturns-yes" className='ml-2' >Yes</label>
                        </div>

                        <div className='py-1'>
                            <input type="radio" id="unfiledTaxReturns-no" defaultChecked={value === "No"} onClick={() => handleForward("No")} name="do_have_one_or_more_unfiled_tax_returns_" value="no" />
                            <label htmlFor="unfiledTaxReturns-no" className='ml-2' >No</label>
                        </div>
                    </div>
                </fieldset>
                {
                    error &&
                    <p className="mt-2 mb-0 text-xs text-red-500 flex">
                        <XCircleIcon className="h-4 w-4 mr-1" /> Please select a value.
                    </p>
                }
            </div>
            <div className="relative flex items-center justify-between w-full h-14 bg-blue-600 rounded-b-md">
                <button
                    id="calcStep3Prev"
                    onClick={() => prevStep(3)}
                    className="flex items-center h-full w-fit rounded-bl-md hover:bg-blue-800 text-white text-base px-5 py-1.5 font-semibold uppercase">
                    <ArrowLeftIcon className='h-5 w-5 mr-2' /> <span className="hidden md:block">Prev</span>
                </button>

                {/* Centered Step Counter */}
                <div className="absolute left-1/2 -translate-x-1/2 text-white opacity-50">
                    3 of 12
                </div>

                {/* Next Button */}
                <button
                    id="calcStep3Next"
                    onClick={() => handleNextStep()}
                    className="flex items-center h-full px-5 font-semibold text-white uppercase bg-blue-600 rounded-br-md hover:bg-blue-800"
                >
                    <span className="hidden md:block">Next</span>
                    <ArrowRightIcon className="w-5 h-5 ml-2" />
                </button>
            </div>
        </div>
    );
}